import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
export function useFeatures() {
  const [f, setF] = useState(cache || { tek_cari: false });
  useEffect(() => { if (!cache) api.get("/meta/features").then(({ data }) => { cache = data; setF(data); }).catch(() => {}); }, []);
  return f;
}
